import zeplinColor from 'theme/Color';
import { DealOutcome } from './types';

export const columns = [
  { id: 'clientName', label: 'Client' },
  { id: 'name', label: 'Deal' },
  { id: 'amount', label: 'Value' },
  { id: 'stageName', label: 'Stage' },
  { id: 'outcome', label: 'Outcome' },
  { id: 'closeDate', label: 'Close Date' },
  { id: 'ownerName', label: 'Owner' },
];

export const sortableColumns = [
  'clientName',
  'amount',
  'stageName',
  'outcome',
  'closeDate',
  'ownerName',
];

export const sortLabels: Record<string, { asc: string; desc: string }> = {
  pipelineType: { asc: 'Start to End', desc: 'End to Start' },
  amount: { asc: 'Lowest to Highest', desc: 'Highest to Lowest' },
  status: { asc: 'Lowest to Highest', desc: 'Highest to Lowest' },
  closeDate: { asc: 'Earliest to Latest', desc: 'Latest to Earliest' },
};

export const outcomeColorMap: Record<DealOutcome, string> = {
  won: zeplinColor.Success,
  lost: zeplinColor.Error,
  passed: zeplinColor.Neutral9,
  'on hold': zeplinColor.AlertInfo,
};
